import React from 'react';
import P, { InferProps } from 'prop-types';
import CardHeader from '@mui/material/CardHeader';

function ModuleClone({ title }: InferProps<typeof ModuleClone.propTypes>) {
  return <CardHeader title={title} titleTypographyProps={{ variant: 'subtitle1' }} />;
}

ModuleClone.propTypes = {
  title: P.string.isRequired,
};

export default ModuleClone;
